import type { WithActiveBranchId } from '@app/api/shared';

export enum IntegrationAuthEndpoints {
  GetQr = 'GetQr',
  RequestQr = 'RequestQr',
  SendPhone = 'SendPhone',
  SendCode = 'SendCode',
  SendPassword = 'SendPassword',
  SetBotToken = 'SetBotToken',
}

export type IntegrationAuthInput = {
  Value: string;
};

export type GetQrRequest = WithActiveBranchId<{
  integrationId: number;
}>;
export type GetQrResponse = {
  Qr: string;
};

export type RequestQrRequest = WithActiveBranchId<{
  integrationId: number;
  /** Выпустить новый QR вместо возврата ещё действующего. */
  force?: boolean;
}>;
export type RequestQrResponse = void;

export type SendAuthValueRequest = WithActiveBranchId<{
  integrationId: number;
  data: IntegrationAuthInput;
}>;
export type SendAuthValueResponse = void;
